import React from 'react';
import { Loader2 } from 'lucide-react';

/**
 * ActionButton - Botones de acción estandarizados
 * 
 * @param {string} variant - 'primary', 'secondary', 'success', 'danger', 'ghost', 'gold'
 * @param {string} size - 'sm', 'md', 'lg'
 * @param {React.Component} icon - Icono de Lucide
 * @param {boolean} loading - Estado de carga
 * @param {boolean} disabled - Deshabilitado
 * @param {boolean} fullWidth - Ancho completo
 */
export const ActionButton = ({
  children,
  variant = 'primary',
  size = 'md',
  icon: Icon,
  iconPosition = 'left',
  loading = false,
  disabled = false,
  fullWidth = false,
  className = '',
  ...props
}) => {
  const variants = {
    primary: 'bg-slate-900 text-white hover:bg-slate-800 border-transparent shadow-sm',
    secondary: 'bg-white text-slate-700 hover:bg-slate-50 border-slate-200 shadow-sm',
    success: 'bg-emerald-600 text-white hover:bg-emerald-700 border-transparent shadow-sm',
    danger: 'bg-red-600 text-white hover:bg-red-700 border-transparent shadow-sm',
    warning: 'bg-amber-500 text-white hover:bg-amber-600 border-transparent shadow-sm',
    ghost: 'bg-transparent text-slate-600 hover:bg-slate-100 hover:text-slate-900 border-transparent',
    gold: 'bg-[#D4AF37] text-black hover:bg-[#C4A030] border-transparent shadow-sm',
    outline: 'bg-transparent text-slate-700 hover:bg-slate-50 border-slate-300',
    'outline-primary': 'bg-transparent text-slate-900 hover:bg-slate-900 hover:text-white border-slate-900',
    'outline-success': 'bg-transparent text-emerald-600 hover:bg-emerald-600 hover:text-white border-emerald-600',
    'outline-danger': 'bg-transparent text-red-600 hover:bg-red-600 hover:text-white border-red-600'
  };

  const sizes = {
    sm: 'h-8 px-3 text-xs gap-1.5',
    md: 'h-10 px-4 text-sm gap-2',
    lg: 'h-12 px-6 text-base gap-2'
  };

  const iconSizes = {
    sm: 'w-3.5 h-3.5',
    md: 'w-4 h-4',
    lg: 'w-5 h-5'
  };

  const baseClasses = 'inline-flex items-center justify-center font-medium rounded-xl border transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed';
  
  return (
    <button
      className={`${baseClasses} ${variants[variant]} ${sizes[size]} ${fullWidth ? 'w-full' : ''} ${className}`}
      disabled={disabled || loading}
      {...props}
    >
      {loading ? (
        <Loader2 className={`${iconSizes[size]} animate-spin`} />
      ) : (
        <>
          {Icon && iconPosition === 'left' && <Icon className={iconSizes[size]} />}
          {children}
          {Icon && iconPosition === 'right' && <Icon className={iconSizes[size]} />}
        </>
      )}
    </button>
  );
};

export default ActionButton;
